///<reference path='../../typings/index.d.ts' />
///<reference path='../config.ts' />
///<reference path='../cardbase.ts' />
///<reference path='../manifest/assets.ts' />
///<reference path='domlayer.ts' />

module agi.expressions.card.layer {
    import Config = agi.expressions.card.Config;
    import Event = agi.expressions.event.Event;
    import AssetManifest = agi.expressions.card.manifest.AssetManifest;
    import Mode = agi.expressions.card.Mode;

    export class PlayButton extends DomLayer{
        protected playButtonUrl:string;
        protected playButtonImg:HTMLImageElement;
        protected playButton:HTMLDivElement;
        protected assets:AssetManifest;

        constructor(
            container:HTMLElement, 
            measuringContainer:HTMLElement, 
            assets:AssetManifest
        ){
            super(container, measuringContainer);
            this.assets = assets;
        }

        public init(){
            //initialize the element
            this.element = document.createElement('div');
            this.element.id = 'expression-play-button-container';
            this.element.style.visibility = 'visible';
            this.element.style.position = 'absolute';
            this.element.style.width = Config.SQUARE_SIZE + "px";
            this.element.style.height = Config.SQUARE_SIZE + "px";
            this.element.style.top = "0px";
            this.element.style.background = "none";
            this.playButtonImg = <HTMLImageElement>document.createElement('img');
            this.playButtonImg.style.width = Config.SQUARE_SIZE + "px";
            this.playButtonImg.style.height = Config.SQUARE_SIZE + "px";
            this.element.appendChild(this.playButtonImg);
            this.playButton = <HTMLDivElement>document.createElement('div');
            this.playButton.style.width = "410px";
            this.playButton.style.height = "400px";
            this.playButton.style.position = "absolute";
            this.playButton.style.top = "128px";
            this.playButton.style.left = "70px";
            this.playButton.style.cursor = "pointer";
            this.playButton.addEventListener('mousedown', (e)=>{this.onPlayClick(e)});
            this.playButton.addEventListener('touchend', (e)=>{this.onPlayClick(e)});
            this.element.appendChild(this.playButton);
            this.container.appendChild(this.element);
            this.resize(null);
        }

        public hide() {
            this.element.style.visibility = "hidden";
            this.element.style.opacity = "0";
        }

        public show() {
            this.element.style.visibility = "visible";
            this.element.style.opacity = "1";
        }

        private onPlayClick(event:TouchEvent|MouseEvent){
            event.preventDefault();
            var playButtonClickedEvent = new Event("playButtonClicked", this);
            this.eventBus.dispatchEvent(playButtonClickedEvent);
            this.hide();
        }
    }
}